import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getIsLoggedIn, setIsLoggedIn } from "@/reducers/commonSlice";
import DoRegisteration from "@/pages/auth/DoRegisteration";
import { jwtDecode } from "jwt-decode";

const RequireAuth = ({ children }) => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isLoggedIn) {
      const urlParams = new URLSearchParams(window.location.search);
      const encryptedCode = urlParams.get("data");

      if (encryptedCode) {
        try {
          const decoded = jwtDecode(encryptedCode);
          console.log("Decoded Data:", decoded);

          if (decoded?.authToken) {
            dispatch(setIsLoggedIn(true));
            localStorage.setItem("token", decoded?.authToken);
          }
        } catch (error) {
          console.error("Failed to decode token:", error);
        }
      }
    }
    setLoading(false);
  }, [isLoggedIn, dispatch]);

  if (loading) {
    return <div></div>;
  }

  if (!isLoggedIn) {
    return <DoRegisteration />;
  }
  return children;
};

export default RequireAuth;
